module.exports = __webpack_public_path__ + "img/user-credit-score.d71508f.svg";